module.exports = __webpack_public_path__ + "static/media/motorcycle.ba62b92f.svg";